"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class Index {
    constructor(parent, attachmentId = null) {
        this.parent = parent;
        this.rc = parent.rc;
        this.attachmentId = attachmentId;
    }
    path(withParameter = true) {
        if (withParameter && this.attachmentId !== null) {
            return `${this.parent.path()}/content/${this.attachmentId}`;
        }
        return `${this.parent.path()}/content`;
    }
    /**
     * Returns a specific message attachment data as media stream.
     * HTTP Method: get
     * Endpoint: /restapi/{apiVersion}/account/{accountId}/extension/{extensionId}/message-store/{messageId}/content/{attachmentId}
     * Rate Limit Group: Medium
     * App Permission: ReadMessages
     * User Permission: ReadMessageContent
     */
    async get(queryParams, restRequestConfig) {
        if (this.attachmentId === null) {
            throw new Error('attachmentId must be specified.');
        }
        const r = await this.rc.get(this.path(), queryParams, { ...restRequestConfig, responseType: 'arraybuffer' });
        return r.data;
    }
}
exports.default = Index;
//# sourceMappingURL=index.js.map